module.exports = __webpack_public_path__ + "img/precs3.ef2d1ebb.png";